import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { all, select, put, takeLatest, takeEvery, take } from 'redux-saga/effects';
import { setCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/actions';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { getStorageEventChannel } from '../../redux/compliantLocalStorage/utils';
import { convertToClientStorageState } from '../../DaEditorWrapper/utils';
import { userLogoutButtonClicked } from '../../SiteHeader/redux/actions';
import { appMounted } from '../../redux/app/actions';
import { saveEditorDraft, removeEditorDraft, uploadDraggedFile } from './actionCreators';
import { getEditorDraftsState } from './selectors';
import { EDITOR_DRAFT_EXPIRATION_DELTA } from './constants';
import { fetchDeviation } from '../../redux/deviations/actionCreators';
import { uploadFile } from '../../redux/uploads/actions';
function cleanExpiredDrafts(draftsState) {
    const newState = {};
    for(const editorId in draftsState){
        const { updatedAt } = draftsState[editorId];
        const minUpdatedDate = Date.now() - EDITOR_DRAFT_EXPIRATION_DELTA;
        if (updatedAt >= minUpdatedDate) {
            newState[editorId] = draftsState[editorId];
        }
    }
    return newState;
}
function* saveEditorDraftHandler({ payload: { editorId, editorState } }) {
    if (!editorState) {
        return;
    }
    const data = {
        textContent: convertToClientStorageState(editorState.rawContentState, editorState.editorContent, editorState.features).editorText,
        updatedAt: Date.now()
    };
    const draftsState = yield select(getEditorDraftsState) || {};
    const mergedDraftsState = _object_spread_props(_object_spread({}, cleanExpiredDrafts(draftsState)), {
        [editorId]: data
    });
    yield put(setCompliantLocalStorageItem({
        key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
        value: JSON.stringify(mergedDraftsState)
    }));
}
function* removeEditorDraftHandler({ payload: { editorId } }) {
    const draftsState = yield select(getEditorDraftsState) || {};
    delete draftsState[editorId];
    yield put(setCompliantLocalStorageItem({
        key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
        value: JSON.stringify(draftsState)
    }));
}
function* uploadDraggedFileHandler({ payload: { file, uploadHelpers } }) {
    const onSuccess = function*({ deviationId }) {
        yield put(fetchDeviation({
            deviationid: deviationId,
            type: 'art',
            onSuccess: (deviation)=>{
                blockKey && uploadHelpers.attachDeviation(deviation, blockKey);
            }
        }));
    };
    const onFailure = ()=>{
    // TODO: handle upload failure
    };
    const dispatchedAction = yield put(uploadFile({
        file,
        onSuccess,
        onFailure
    }));
    const uploadId = dispatchedAction.payload.uploadId;
    const blockKey = uploadHelpers.attachUpload(uploadId);
}
function* handleAppMounted() {
    const channel = getStorageEventChannel();
    while(true){
        const event = yield take(channel);
        if (event.key !== CompliantLocalStorageKeys.EDITOR_DRAFTS || !event.newValue) {
            continue;
        }
        yield put(setCompliantLocalStorageItem({
            key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
            value: event.newValue
        }));
    }
}
function* handleUserLogout() {
    // On logout clear drafts to avoid leaking data
    yield put(setCompliantLocalStorageItem({
        key: CompliantLocalStorageKeys.EDITOR_DRAFTS,
        value: JSON.stringify({})
    }));
}
export default function* saga() {
    yield all([
        takeLatest(saveEditorDraft, saveEditorDraftHandler),
        takeLatest(removeEditorDraft, removeEditorDraftHandler),
        takeEvery(uploadDraggedFile, uploadDraggedFileHandler),
        takeEvery(appMounted, handleAppMounted),
        takeEvery(userLogoutButtonClicked, handleUserLogout)
    ]);
}

//# sourceMappingURL=saga.js.map